// extracted by mini-css-extract-plugin
export default {"viewmsg":"ViewPracticeMessages_viewmsg__LgmNA","title":"ViewPracticeMessages_title__YiJwI","content":"ViewPracticeMessages_content__yjD57"};